import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetFranchiseManagerDetail = () => {
	const [userRole] = useRoleCookie()
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const rolePath = getApiRolePath(userRole)
	const fetchData = () => {
		fetchRequest('GET', `/${rolePath}/franchise/manager/${idx}/detail`)
	}

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'manager_idx')
					setAlert('프랜차이즈 매니저 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('매니저 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, fetchData]
}

export default useGetFranchiseManagerDetail
